import { h, svgUse } from '../../utils/dom.js';

export function ListItem({ icon, title, subtitle, trailing, onSelect }) {
  const props = { class: 'list-item' + (onSelect ? ' is-clickable' : '') };
  if (onSelect) {
    props.role = 'button';
    props.tabindex = '0';
    props.onclick = onSelect;
    props.onkeydown = (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onSelect();
      }
    };
  }
  return h('div', props,
    h('div', { class: 'li-icon' }, svgUse(icon)),
    h('div', { class: 'li-text' }, h('b', {}, title), subtitle ? h('span', {}, subtitle) : null),
    trailing || null,
  );
}
